<template>
  <div>
    <v-container fluid>
      <v-row dense class="pb-0">
        <v-col cols="3">
          <date-range :from.sync="from" :to.sync="to" v-model="dateDisplay" @change="refresh()" hide-details option="Last 30 days"/>
        </v-col>
        <v-col cols="3">
          <v-autocomplete label="Mash bill" dense outlined hide-details :items="mashBills" item-text="name" item-value="id" v-model="mashBillId"/>
        </v-col>
        <v-col class="text-right pr-2">
          <v-btn icon @click="printHtml('Mashing activity', report())"><v-icon>mdi-printer</v-icon></v-btn>
          <v-tooltip bottom open-delay="1000" v-if="company.allowCSVExport">
            <template v-slot:activator="{on}">
              <v-btn icon @click="exportCSV" v-on="on"><v-icon>mdi-download</v-icon></v-btn>
            </template>
            Export as CSV file
          </v-tooltip>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="mx-4 pa-4 overflow-y" height="calc(100vh - 184px)">
      <span v-html="report()"/>
    </v-card>

  </div>
</template>

<script>
import fileSaver from 'file-saver';
import printHtml from '@/mixins/printHtml'

export default {
  name: 'ReportsMashingActivity',
  mixins: [printHtml],
  data() {
    return {
      from: null,
      to: null,
      dateDisplay: '',
      mashBills: [{name:'All mash bills',id:null},{name:'No mash bill',id:''},{divider:true}],
      mashBillId: null,
      mashes: [],
      loading: true,
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    mashBillName() {
      return this.mashBills.find(mashBill => mashBill.id === this.mashBillId)?.name ?? '';
    },
    mashesList() {
      if (this.mashBillId === null)
        return this.mashes;
      return this.mashes.filter(mash =>
        (this.mashBillId === '' && mash.mashBillId === null) || (this.mashBillId !== '' && this.mashBillId === mash.mashBillId)
      );
    }
  },
  async created() {
    this.$emit('name', 'Mashing activity')
    if (this.$route.query.from && this.$route.query.to) {
      this.from = this.$route.query.from;
      this.to = this.$route.query.to;
    }
    if (this.$route.query.mashBillId)
      this.mashBillId = this.$route.query.mashBillId;

    this.$lazyListLoad(this.mashBills, 'mashBills2', 'id,name', 100, [{field:'active', comparator:'eq', value:'true'}]);
    this.loading = false;
  },
  methods: {
    async refresh() {
      this.loading = true;
      const results = await this.$apiCall(`query ReportsMashingActivity($from:Date!,$to:Date!) {
                                                mashActivity(from:$from,to:$to) {
                                                  id,date,mashBillId,mashBillName,
                                                  inputs{name,volume,units},
                                                  outputs{name,volume}
                                                }
                                              }`,
                                          {from:this.from,to:this.to});
      if (!results.error)
        this.mashes = results.data.mashActivity;
      this.loading = false;
    },

    report() {
    const lines = [
                    `<style>
                      @page {size:landscape}
                      .reports-mash-activity {font-family: Roboto, sans-serif; font-size:14px;width:100%;border-spacing:0}
                      .reports-mash-activity th {height:36px;padding:0 16px}
                      .reports-mash-activity td {height:36px;padding:0 16px}
                      .reports-mash-activity .title {font-size:18px;text-transform:uppercase}
                      .reports-mash-activity .sup-title {font-weight:normal;font-size:22px}
                      .reports-mash-activity .sub-title {font-weight:normal;height:inherit;padding-bottom:20px;font-size:14px}
                      .reports-mash-activity .header th {border-bottom:1px solid #000;margin-bottom:20px}
                      .reports-mash-activity .text-left {text-align:left}
                      .reports-mash-activity .text-right {text-align:right}
                    </style>
                    <table class="reports-mash-activity">
                     <thead>
                        <tr>
                          <th colspan="5" class="sup-title">${this.company.name}</th>
                        </tr>
                        <tr>
                          <th colspan="5" class="title">Mashing activity</th>
                        </tr>
                        <tr>
                           <th colspan="5" class="sub-title">${this.dateDisplay}</th>
                        </tr>
                        <tr class="header">
                            <th width="15%" class="text-left">Date</th>
                            <th width="20%" class="text-left">Mash bill</th>
                            <th width="10%" class="text-left">In/Out</th>
                            <th width="25%" class="text-left">Item/Fermenter</th>
                            <th width="20%" class="text-left text-right">Volume</th>
                          </tr>
                      </thead>
                      <tbody>`
    ];
    for (const mash of this.mashesList) {
      let i = 0;
      for (const input of mash.inputs) {
        lines.push(`<tr>`);
        if (i === 0) {
          lines.push(`<td>${this.$formatDate(mash.date)}</td>`);
          lines.push(`<td>${mash.mashBillName ? mash.mashBillName : ''}</td>`);
        }
        else {
          lines.push(`<td/>`)
          lines.push(`<td/>`)
        }
        lines.push(`<td>IN</td>`);
        lines.push(`<td>${input.name}</td>`);
        lines.push(`<td class="text-right">${input.volume} ${input.units}</td>`);
        lines.push(`</tr>`);
        i++
      }
      for (const output of mash.outputs) {
        lines.push(`<tr>`);
        lines.push(`<td/>`)
        lines.push(`<td/>`)
        lines.push(`<td>OUT</td>`);
        lines.push(`<td>${output.name}</td>`);
        lines.push(`<td class="text-right">${output.volume} litres</td>`);
        lines.push(`</tr>`);
        i++
      }
    }
    lines.push(`</tbody>`);
    lines.push(`</table>`);
    return lines.join('');
    },

    exportCSV() {
      const lines = [ `"${this.company.name}",,,,`,
                      `"Mashing activity",,,,`,
                      `"${this.dateDisplay}",,,,`,
                      `"Date","Mash bill","In/Out","Item/Fermenter","Volume"`
                    ];
      for (const mash of this.mashesList) {
        let i = 0;
        for (const input of mash.inputs) {
          let line = i === 0 ? `"${mash.date}","${mash.mashBillName ? mash.mashBillName : ''}",` : `,,`;
          line += `"IN","${input.name}","${input.volume} ${input.units}"`;
          lines.push(line);
          i++
        }
        for (const output of mash.outputs) {
          lines.push(`,,"OUT","${output.name}","${output.volume}"`);
          i++;
        }
      }

      // Write CSV file
      const blob = new Blob([lines.join('\r\n')], {type: "text/plain;charset=utf-8"});
      fileSaver.saveAs(blob, 'Mashing activity.csv');
    }
  }
}
</script>